export default "__VITE_ASSET__PYcHHmFI__"